import React from "react";
import { FeatherRefreshCw, FeatherSearch } from "@subframe/core";
import { Button } from "../../../../ui/components/Button";
import { TextField } from "../../../../ui/components/TextField";
import { SortDropdown } from "../../../../shared/presentation/components/SortDropdown";
import { JournalListStatus } from "../../domain";
import { JournalStatusFilterPills } from "./JournalStatusFilterPills";

interface JournalListToolbarProps {
  status: JournalListStatus;
  onStatusChange: (status: JournalListStatus) => void;
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  sort: {
    by: string;
    order: string;
    label: string;
  };
  onSortChange: (sortBy: string, sortOrder: string, label: string) => void;
  onRefresh: () => void;
  loading: boolean;
}

export const JournalListToolbar: React.FC<JournalListToolbarProps> = ({
  status,
  onStatusChange,
  searchTerm,
  onSearchTermChange,
  sort,
  onSortChange,
  onRefresh,
  loading,
}) => {
  return (
    <div className="flex w-full items-center justify-between gap-4">
      <JournalStatusFilterPills value={status} onChange={onStatusChange} />

      <div className="flex items-center gap-4">
        <TextField
          className="h-auto w-64 flex-none"
          variant="filled"
          label=""
          helpText=""
          icon={<FeatherSearch />}
        >
          <TextField.Input
            placeholder="Search journals..."
            value={searchTerm}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              onSearchTermChange(event.target.value)
            }
          />
        </TextField>
        <SortDropdown
          currentSort={sort}
          onSortChange={onSortChange}
          disabled={loading}
        />
        <Button
          variant="neutral-tertiary"
          icon={<FeatherRefreshCw />}
          onClick={onRefresh}
          disabled={loading}
        >
          Refresh
        </Button>
      </div>
    </div>
  );
};
